import { render, staticRenderFns } from "./ProfileDeleteReveals.vue?vue&type=template&id=7d83da98&"
import script from "./ProfileDeleteReveals.vue?vue&type=script&lang=js&"
export * from "./ProfileDeleteReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports